	<template>
  <div class="header">
    <!-- Preloader -->
    <!-- <div class="preloader-it">
		<div class="la-anim-1"></div>
    </div>-->
    <!-- /Preloader -->
    <div class="wrapper theme-3-active pimary-color-green">
      <!-- Top Menu Items -->
      <nav class="navbar navbar-inverse navbar-fixed-top">
        <div class="mobile-only-brand pull-left" style="background:transparent;">
          <div style="background-color:#fff;" class="nav-header pull-left">
            <div class="logo-wrap">
              <router-link to="/dashboard">
                <!-- <img
                  class="brand-img"
                  src="/dist/img/logocolor.png"
									:style="menu_open ? 'height:50px; margin-left: 20px;' : 'height:35px;'"
                  style="height:35px;margin-left:-10px;margin-top:-7px;"
                  alt="brand"
                > -->
                <img
                  class="brand-img"
                  src="https://loopdigital-nutrivitas.s3.us-east-2.amazonaws.com/new-logo-hor.png"
                  alt="brand"
                >
              </router-link>
            </div>
          </div>
          <a
            id="toggle_nav_btn"
            class="toggle-left-nav-btn inline-block ml-20 pull-left"
            href="javascript:void(0);"
						@click="menu_open = !menu_open"
          >
            <i class="zmdi zmdi-menu" style="color: #ffffff !important"></i>
          </a>
          <a
            id="toggle_mobile_search"
            data-toggle="collapse"
            data-target="#search_form"
            class="mobile-only-view"
            href="javascript:void(0);"
          >
            <i class="zmdi zmdi-search"></i>
          </a>
          <a id="toggle_mobile_nav" class="mobile-only-view" href="javascript:void(0);">
            <i class="zmdi zmdi-more"></i>
          </a>
        </div>
        <div id="mobile_only_nav" class="mobile-only-nav pull-right">
          <ul class="nav navbar-right top-nav pull-right">
            <li class="dropdown auth-drp">
              <a href="#" class="dropdown-toggle pr-0" data-toggle="dropdown">
                <img :src="profile_picture" alt="user_auth" class="user-auth-img img-circle">
              </a>
              <ul
                class="dropdown-menu user-auth-dropdown"
                data-dropdown-in="flipInX"
                data-dropdown-out="flipOutX"
              >
                <li>
                  <router-link to="/profile">
                    <i class="zmdi zmdi-account"></i>
                    <span>Profile</span>
                  </router-link>
                </li>
                <li class="divider"></li>
                <li>
                  <a href="#" @click="updateMe">
                    <i class="zmdi zmdi-refresh"></i>
                    <span>Update Me</span>
                  </a>
                </li>
                <li v-if="!$store.getters.user.vip_user">
                  <router-link to="/profile/upgrade">
                    <i class="zmdi zmdi-star"></i>
                    <span>Go VIP</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/t&c">
                    <i class="zmdi zmdi-info"></i>
                    <span>Terms & Conditions</span>
                  </router-link>
                </li>
                <li class="divider"></li>
                <li>
                  <a href="#" data-toggle="modal" data-target="#logoutModal">
                    <i class="zmdi zmdi-power"></i>
                    <span>Log Out</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>

      <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Logout</h5>
          </div>
          <div class="modal-body">
            Are you sure you want to logout?
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="logout">Logout</button>
          </div>
          </div>
        </div>
      </div>

      <!-- /Top Menu Items -->
      <!-- Left Sidebar Menu -->
      <div class="fixed-sidebar-left">
        <ul class="nav navbar-nav side-nav" style="padding-top:20px;background-color:#fff;">
          <!-- <li>
					<div class="pictureProfile">
						<div class="row">
							<div class="col-md-12">
								<div class="col-md-7 col-xs-7">
									<img :src="profile_picture" alt="user_auth" class="user-auth-img img-circle imgProfile"/>
								</div>
								<div class="col-md-5 col-xs-5">
									<p class="profileName pull-right text-center"><strong>{{ me.name }}</strong></p>
									<p class="pull-right">{{this.$store.getters.user.weight}} {{current_weight_units}}</p>
								</div>
							</div>
						</div>
						
					</div> 	
          </li>-->
          <li>
            <div class="pull-left">
              <hr>
              <h6 class="mainTitleNavbar right-nav-text" style="color: #027AC9">PROGRESS</h6>
            </div>
            <div class="clearfix"></div>
          </li>
          <li >
            <router-link to="/dashboard">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/dashboard.png" alt="">
                <span class="right-nav-text">Dashboard</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <router-link to="/weight-tracker">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/weight_tracker.png" alt="">
                <span class="right-nav-text">Weight Tracker</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>

          <li>
            <router-link to="/water-tracker">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/glass-of-water.png" alt="">
                <span class="right-nav-text">Water Tracking</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <router-link to="/exercise">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/exercise_tracking.png" alt="">
                <span class="right-nav-text">Exercise Tracking</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <router-link to="/measurement-tracker">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/measurement_tracker.png" alt="">
                <span class="right-nav-text">Measurement Tracker</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>

          <li style="margin-top:5px;">
            <div class="pull-left">
              <hr>
              <h6 class="mainTitleNavbar right-nav-text" style="color: #FF530E">FOOD</h6>
            </div>
            <div class="clearfix"></div>
          </li>
          <li>
            <router-link style="color:white;" to="/food-tracker">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/food.png" alt="">
                <span class="right-nav-text">Food Tracker</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <router-link style="color:white;" :to="$store.getters.user.vip_user ? '/shoppinglist' : '/profile/upgrade'">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/shopping_basket.png" alt="">
                <span class="right-nav-text">Shopping List</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <a style="color:white;" href="http://nutrivitas.com/blog" target="_blank">
              <div class="pull-left">
                <i class="zmdi zmdi-favorite mr-20"></i>
                <span class="right-nav-text">Healthy Tips</span>
              </div>
              <div class="clearfix"></div>
            </a>
          </li>

          <li style="margin-top:5px;">
            <div class="pull-left">
              <hr>
              <h6 class="mainTitleNavbar right-nav-text" style="color: #D827FF">DIET</h6>
            </div>
            <div class="clearfix"></div>
          </li>
          <li>
            <router-link style="color:white;" to="/keto">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/keto.png" alt="">
                <span class="right-nav-text">Keto Calculator</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <router-link style="color:white;" to="/menopause">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/meno.png" alt="">
                <span class="right-nav-text">Meno Calculator</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li>
            <router-link to="/food-tracker?smp=1">
              <div class="pull-left">
                <img class="menuicon" src="/dist/img/icons/start_diet_plan.png" alt="">
                <span class="right-nav-text">Start Diet Plan</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
          <li v-if="!$store.getters.user.vip_user">
            <router-link to="/profile/upgrade">
              <div class="pull-left">
                <i class="zmdi zmdi-star mr-20"></i>
                <span class="right-nav-text">Go VIP</span>
              </div>
              <div class="clearfix"></div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- /Left Sidebar Menu -->
    <!-- Meno Modal -->
    <div class="modal fade" id="menopauseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Meno Calculator</h5>
        </div>
        <div class="modal-body">
          Menopause diet calculator is only available for females.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-nutri-green" data-dismiss="modal">Okay</button>
        </div>
        </div>
      </div>
    </div>
    <!-- Menu Modal End -->

  </div>
</template>

<script>
import API from "../../services/api.js";
import { mapMutations } from "vuex";
const api = new API();
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datetime,
    Datepicker
  },
  data: function() {
    return {
      available_mealplans: null,
      newMealPlanDate: null,
			newMealPlan: null,
      profile_picture: this.$store.getters.user.meta_data.gender == "female" ? '/dist/img/userthumb_female.png' : '/dist/img/userthumb.png',
      is_toggle: false,
			me: this.$store.getters.user,
			menu_open: true,
      current_weight_units:
        this.$store.getters.user.meta_data.preferred_units == "metric"
          ? "kg"
          : "lbs"
    };
  },
  created: function() {},
  mounted: function() {
    api.getAvailableMealPlans(this.date).then(async response => {
      if (response.data.success) {
        this.available_mealplans  = response.data.data;
      }
    });
  },
  methods: {
    // startMealPlan(){
		// 	this.isLoading = true;
		// 	api.startMealPlan(this.newMealPlan.id, this.newMealPlanDate).then(async response => {
		// 		if (response.data.success) {
		// 			this.isLoading = false;
		// 			const elem = this.$refs.newMealPlanClose;
		// 			elem.click();
		// 			swal("Mealplan Started!", "Your mealplan has been recorded!", "success");
		// 			setTimeout(() => {
		// 				swal.close();
		// 			}, 4000);
		// 			api.me();
		// 		}
		// 	});
		// },
    logout() {
      this.$store.commit("resetStore");
      this.navigate("/");
    },
    updateMe() {
      api.me();
    }
  },
};
</script>

<style scoped>
.menuicon {
  width: 20px;
  margin-right: 10px;
}
.info-btn{
  font-size:28px;
  margin-top:7px;
  margin-left:-4px;
}

.brand-img{
  height:50px;
  margin-left:-17px;
  margin-top:-7px;
}

.user-auth-img{
  /* border: white solid 1px; */
  width: 60px !important;
  height: 60px !important;
}

.fixed-sidebar-left .side-nav {
  overflow: hidden;
}

.logo-wrap {
  padding: 0;
}

i {
  color: #7ec347 !important;
}

.fixed-sidebar-left .side-nav {
  overflow: hidden;
}

.pictureProfile {
  background-color: black;
}

.imgProfile {
  margin-top: 5px;
  border-top: 15px;
  border-color: red;
}

span {
  color: #333;
}

.profileName {
  color: green;
}

.mainTitleNavbar {
  padding-left: 14px;
  color: #333;
}

.navbar {
  background: rgb(94,204,246) !important;
  background: linear-gradient(135deg, rgba(94,204,246,1) 0%, rgba(0,94,223,1) 100%) !important;
  border-bottom:none;
}
</style>


// WEBPACK FOOTER //
// src/components/common/AppHeader.vue